// extracted by mini-css-extract-plugin
export default {"input":"Input_input__7xtRd"};